import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;

export const FormSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M1.75.75h20.5s1 0 1 1v20.5s0 1-1 1H1.75s-1 0-1-1V1.75s0-1 1-1"></path>
      <path d="M4 6.5V5h6v1.5m-3 4.25V5m6.25 0h6.25m-6.25 4.5h6.25M4 14h15.5M4 18.5h15.5"></path>
    </g>
  </svg>
);
const FormIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FormSvg} {...props} />
);

export default FormIcon;
